import React, { useRef } from "react";
import MainImage5 from "../../assets/AboutImage6-1.jpg"; // Assuming this image works for Local SEO
import AboutImage from "../../assets/Local/LawOffice.jpg";
import Footer from "../../components/Footer";
import About from "../../components/About";


// Importing images from the assets folder
import TestimonyImage1 from "../../assets/VisibilityAudit/VisibilityAudit4.png";
import TestimonyImage2 from "../../assets/VisibilityAudit/VisibilityAudit2.png";
import TestimonyImage4 from "../../assets/VisibilityAudit/VisibilityAudit11.png";
import TestimonyImage5 from "../../assets/VisibilityAudit/VisibilityAudit5.png";
import TestimonyImage6 from "../../assets/VisibilityAudit/VisibilityAudit6.png";
import TestimonyImage7 from "../../assets/VisibilityAudit/VisibilityAudit7.png";
import TestimonyImage8 from "../../assets/VisibilityAudit/VisibilityAudit8.png";
import TestimonyImage9 from "../../assets/VisibilityAudit/VisibilityAudit9.png";
import TestimonyImage10 from "../../assets/VisibilityAudit/VisibilityAudit10.png";
import TestimonyImage11 from "../../assets/VisibilityAudit/VisibilityAudit.png";
import Testimony from "../../components/Testimony";
import NavLite from "../../components/NavLite";




function LocalSEO() {
  <main>
  <title>Local SEO for Women-Led Businesses | Dominate Your Local Market | Her Growth Co.</title>
<meta
name="description"
content="Her Growth Co offers expert local SEO tailored for women entrepreneurs looking to rank in their city and drive real traffic that converts."
/>
<meta
name="keywords"
content="local SEO services for women-led businesses, boost neighborhood visibility, rank locally as a female expert, Austin-based local SEO for women, small business local search strategy, geo-targeted growth plan, hyperlocal optimization for female founders, maps ranking strategy, Google local SEO plan, seo services austin, local seo agency texas, niche seo for consultants, expert seo for coaches, texas seo consultant, google business profile seo texas, seo keyword research services, austin link building services, seo for service businesses texas, female entrepreneur seo austin, technical seo expert austin, seo agency for small business, seo for personal brands texas, organic seo services texas, austin seo campaign management, seo lead generation austin, online visibility services austin, targeted seo strategies texas, seo for niche industries, austin digital footprint growth, seo services for creatives texas, top-ranking seo agency austin, seo for women-owned brands texas, local business seo optimization austin, female founder seo fort worth, female founder seo houston"
/>
</main>
  const containerRef = useRef(null);

  const handleScrollLeft = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: -1040, behavior: "smooth" });
    }
  };

  const handleScrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: 1040, behavior: "smooth" });
    }
  };

  const testimonials = [
    { image: TestimonyImage1, name: "David James", role: "CEO/Chairman" },
    { image: TestimonyImage2, name: "Sarah Lee", role: "Founder" },
    { image: TestimonyImage4, name: "Emily White", role: "Product Manager" },
    { image: TestimonyImage5, name: "Michael Brown", role: "CTO" },
    { image: TestimonyImage6, name: "Linda Green", role: "COO" },
    { image: TestimonyImage7, name: "Emily White", role: "Product Manager" },
    { image: TestimonyImage8, name: "Michael Brown", role: "CTO" },
    { image: TestimonyImage9, name: "Linda Green", role: "COO" },
    { image: TestimonyImage10, name: "Linda Green", role: "COO" },
    { image: TestimonyImage11, name: "Linda Green", role: "COO" },
  ];

  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F4F3E1 ]">
      <title>Local SEO Accelerator Package | Boost Website Local Visibility | Her Growth Co</title>
      <meta
        name="description"
        content="Quickly improve your local search rankings with our Local SEO Accelerator Package. We optimize GBP, build citations, and provide performance reporting. Schedule a consultation today!"
      />
      <meta
        name="keywords"
        content="local seo package, local seo services, google business profile optimization, local citation building, local keyword research, online review management, local content optimization, local ranking, performance reporting, local seo strategy, local visibility, local clients, local marketing, local seo for women, law firm local seo, consulting local seo, finance local seo, austin local seo, local SEO women business, web design women Austin, web design women Houston, web design women Dallas, web design women Texas, SEO for women owned businesses Austin, SEO for women owned businesses Houston, SEO for women owned businesses Dallas, SEO for women owned businesses Texas, women business website Austin, women business website Houston, women business website Dallas, women business website Texas, local web design for women entrepreneurs"
      />

      <section>
        <div
          className="relative bg-cover bg-center h-auto"
          style={{ backgroundImage: `url(${MainImage5})` }}
        >
<NavLite/>

          <div className="flex flex-col max-w-2xl py-12 md:py-16 lg:py-10 gap-10 ml-10 ">
            <div className="flex flex-col items-start gap-y-5 bg-black/1 backdrop-blur-sm">
              <h1 className="text-left text-3xl font-bold md:text-5xl text-white uppercase ">
              Accelerate Your Local Presence:
                <span className="bg-[#CFF098] text-black">$499</span> Local SEO
                Accelerator.
              </h1>
              <p className="text-left text-white bg-black/1 backdrop-blur-sm max-w-2xl text-xl font-bold italic">
                Get targeted local SEO optimization to quickly boost your
                visibility and attract local clients.
              </p>
            </div>
            <div className="flex flex-col gap-4 font-regular sm:flex-row">
              <a
                href="https://cal.com/woaomwebdesign/15min" // Replace with your booking link
                className="flex rounded-full items-center gap-4 bg-[#CFF098] px-6 py-3 text-black border-[1px] border-black shadow-md"
              >
                <p>Schedule Your Local SEO Consultation</p>
              </a>
            </div>
          </div>
        </div>

        <section className="bg-[#F7F3F2]">
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex flex-col items-center text-center">
              <div className="flex items-center rounded-md px-3 py-1">
                <p className="text-sm uppercase mb-12 text-black">
                  Local SEO Accelerator
                </p>
              </div>
              <h2 className="text-3xl font-regular md:text-5xl text-black max-w-2xl">
                Dominate Your Local Market: What's Included in Your Local SEO
                Package.
              </h2>
              <p className="mb-8 mt-4 max-w-lg text-base text-black md:mb-12 md:text-lg font-light">
                This package is designed to quickly and effectively improve
                your local search rankings and visibility, attracting more
                local clients.
              </p>
            </div>

            <div className="grid gap-5 sm:grid-cols-2 md:grid-cols-3 md:gap-4 mb-10">
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                  Google Business Profile (GBP) Optimization
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                  Complete optimization of your GBP for maximum local
                  visibility.
                </p>
              </div>

              <div className="grid gap-6 border border-solid border-black p-8 md:p-10 ">
                <h3 className="text-xl font-semibold text-black uppercase">
                  Local Citation Building
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                  Creation and optimization of local citations for consistent
                  online presence.
                </p>
              </div>
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                  Local Keyword Research & Implementation
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                  In-depth research and implementation of local keywords for
                  targeted reach.
                </p>
              </div>
            </div>

            <div className="grid gap-5 sm:grid-cols-2 md:grid-cols-3 md:gap-4 mb-10">
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                  Online Review Management
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                  Guidance on soliciting and managing online reviews.
                </p>
              </div>

              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                  Local Content Optimization
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                  Optimization of website content for local search terms.
                </p>
              </div>
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                  Local Ranking & Performance Reporting
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                  Monthly reports on local search rankings and performance.
                </p>
              </div>
            </div>

            <div className="grid gap-5 sm:grid-cols-2 md:grid-cols-3 md:gap-4">
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                  Local SEO Strategy Session
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                  Strategy session to explain actions and provide tips for
                  further local SEO goals.
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center mt-10">
              <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black">
                Schedule Your Local SEO Consultation →
              </button>
              <p className="text-black text-lg font-light mt-6 w-[400px] text-center">
                Let's discuss how we can boost your local presence.
              </p>
            </div>
          </div>
        </section>



        <section className="">
          <div className="bg-[#F7F3F2] h-auto">
            <h2 className="text-center text-2xl font-bold md:text-3xl text-black pt-16 mb-16 uppercase">
              Our{" "}
              <span className="bg-[#CFF098] text-black italic">
                Local SEO
              </span>{" "}
              Projects
            </h2>

            {/* Left Arrow Button */}
            <button
              className="absolute top-1/2 left-0 transform -translate-y-1/2 z-10 p-6 pt-28"
              onClick={handleScrollLeft}
            >
              {/* Left Arrow SVG */}
              {/* <svg
                width="50"
                height="50"
                viewBox="0 0 72 73"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="1"
                  width="71"
                  height="71"
                  rx="35.5"
                  stroke="#000000" // White color for the background circle stroke
                />
                <path
                  d="M44 35.5H31.83L37.42 29.91L36 28.5L28 36.5L36 44.5L37.41 43.09L31.83 37.5H44V35.5Z"
                  fill="#000000" // White color for the arrow itself
                />
              </svg> */}
            </button>

            <div className="relative flex items-center justify-center">
              <div
                ref={containerRef}
                className="flex overflow-x-auto gap-28 py-6 scroll-smooth scroll-m-0  max-w-[1040px] w-full" // Limit the width to 4 items
              >
                {testimonials.map((testimonial, index) => (
                  <div key={index} className="min-w-[650px]">
                    <img
                      className="object-cover w-full h-auto"
                      src={testimonial.image} // Display the image from assets
                      alt={`Testimonial ${index + 1}`}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Right Arrow Button */}
            <button
              className="absolute top-1/2 right-0 transform -translate-y-1/2 z-10 p-6 pt-28"
              onClick={handleScrollRight}
            >
              {/* Right Arrow SVG */}
              {/* <svg
              width="50"
              height="50"
              viewBox="0 0 72 73"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="1"
                width="71"
                height="71"
                rx="35.5"
                stroke="#000000" // White color for the background circle stroke
              />
              <path
                d="M36 28.5L34.59 29.91L40.17 35.5H28V37.5H40.17L34.59 43.09L36 44.5L44 36.5L36 28.5Z"
                fill="#000000" // White color for the arrow itself
              />
            </svg> */}
            </button>
          </div>
        </section>




        <section>
       <Testimony/>
        </section>

        {/* Our Projects */}

        <section className="">
          {/* ... (Testimonials section remains the same) ... */}
        </section>

    

        <section
          className="bg-cover bg-center"
          style={{ backgroundImage: `url(${AboutImage})` }}
        >
          <div className="">
            <div className="mx-auto w-full text-center bg-[#000000] bg-opacity-60 p-6">
              <h2 className="mx-auto mb-2 max-w-3xl flex-col text-3xl font-bold md:mb-6 md:text-4xl lg:mb-6  text-white ">
                Ready to Dominate Your Local Market?
              </h2>
              <p className="mx-auto mb-2 max-w-xl text-sm text-gray-300 sm:text-base md:mb-4">
                Boost your local visibility and attract more clients with our
                Local SEO Accelerator Package.
              </p>
              <a
                href="https://cal.com/woaomwebdesign/15min" // Replace with your booking link
                className="mb-4 inline-block text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black"
              >
                Schedule Your Local SEO Consultation
              </a>
            </div>
          </div>
        </section>

        <About />

        <Footer />
      </section>
    </main>
  );
}

export default LocalSEO;